export var textToHtml = function (txt) {
    var html = txt;
    var searchReplace = [
        ["\r\n\r\n", "</p><p class='nice'>"],
        ["\n\n", "</p><p class='nice'>"],
        ["\r\n", "<br />"],
        ["\n", "<br />"],
    ];
    searchReplace.forEach(function (_a) {
        var needle = _a[0], replace = _a[1];
        var counter = 0;
        // Fallback with counter, prevent infinity loop
        while ((html === null || html === void 0 ? void 0 : html.indexOf(needle)) !== -1 && counter < 10) {
            html = html === null || html === void 0 ? void 0 : html.replace(needle, replace);
            counter++;
        }
    });
    return '<p class="nice">' + html + '</p>';
};
